import { REFRIGERANT_EVENTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/refrigerant_events_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import {
	REFRIGERANT_ASSET_LEDGER_TC,
	REFRIGERANT_CHECK_OUT_EVENTS_TC,
	REFRIGERANT_EVENTS_ADVANCED_FILTERS,
	REFRIGERANT_EVENTS_TC,
	REFRIGERANT_SERVICING_RECORD_TC,
} from '../utils/RefrigerantUtils';

// `getRecordsForTargetCollection` throws on a name that is not declared here, so every collection a
// screen uses has to be listed up front.
const initialState: any = standardInitialStateGenerator([
	REFRIGERANT_EVENTS_TC,
	REFRIGERANT_EVENTS_ADVANCED_FILTERS,
	REFRIGERANT_ASSET_LEDGER_TC,
	REFRIGERANT_SERVICING_RECORD_TC,
	REFRIGERANT_CHECK_OUT_EVENTS_TC,
]);

// The ledger is append-only and keyed by its own numeric `id`; there is no update path, so a record
// only ever enters this slice once.
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
